import { giphyGreen } from '@giphy/colors'
import styled, { css, keyframes } from 'styled-components'
import { ZoomMakerStatus } from '../types'

const wave = keyframes`
    0% { transform: translate3d(0, 0, 0); }
    100% { transform: translate3d(-100px, 0, 0); }
`

const slideUp = keyframes`
    0% { transform: translate3d(0, 100%, 0); }
    100% { transform: translate3d(0, 0, 0); }
`

const Container = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    left: 0;
    justify-content: center;
    overflow: hidden;
    position: absolute;
    top: 0;
    width: 100%;
`

const Progress = styled.div<{ animating: boolean }>`
    background: ${giphyGreen};
    height: 100%;
    left: 0;
    opacity: 0.85;
    position: absolute;
    top: 0;
    width: 100%;

    svg {
        bottom: 100%;
        left: 0;
        margin-bottom: -1px;
        position: absolute;
    }

    ${(props) =>
        props.animating &&
        css`
            animation: ${slideUp} 30s ease-out 1s 1 normal backwards;
            top: 60px;

            svg {
                animation: ${wave} 1s linear infinite;
            }
        `}
`

const Label = styled.div`
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    position: relative;
    text-align: center;
    text-shadow: 0 2px 6px rgba(0, 0, 0, 0.33);
`

const getStatusLabel = (status?: ZoomMakerStatus) => {
    switch (status) {
        case ZoomMakerStatus.Downloading:
            return 'Downloading your Backdrop...'
        case ZoomMakerStatus.Uploading:
            return 'Uploading your Backdrop...'
        case ZoomMakerStatus.Creating:
            return 'Creating your Backdrop...'
        case ZoomMakerStatus.Complete:
            return 'Complete!'
        default:
            return ''
    }
}

type Props = {
    status: ZoomMakerStatus
}

const ZoomMakerDownloadLoader = ({ status }: Props) => {
    const isComplete = status === ZoomMakerStatus.Complete
    return (
        <Container>
            <Progress animating={!isComplete}>
                <svg width="698" height="51" viewBox="0 0 698 51" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 50.988V28.474C24.826 28.474 24.826 0 49.654 0 74.48 0 74.48 28.474 99.306 28.474 124.14 28.474 124.14 0 148.97 0l.34.002.344-.002c24.713 0 24.826 28.215 49.314 28.472l-.336.002C223.461 28.474 223.461 0 248.29 0l.339.002.342-.002c24.715 0 24.83 28.208 49.316 28.472l-.343.002C322.77 28.474 322.77 0 347.595 0l.346.002.348-.002c24.71 0 24.825 28.207 49.306 28.472l-.345.002C422.08 28.474 422.08 0 446.914 0l.339.002.342-.002c24.715 0 24.828 28.214 49.316 28.472l-.336.002C521.404 28.474 521.404 0 546.232 0l.34.002.342-.002c9.443 0 15.296 4.119 20.288 9.223 8.61 8.183 15.199 18.899 30.06 19.242l-.687.009C621.404 28.474 621.404 0 646.232 0 671.058 0 673.174 28.474 698 28.474v22.514H0z"
                        fill={giphyGreen}
                        fillRule="evenodd"
                    />
                </svg>
            </Progress>
            <Label>{getStatusLabel(status)}</Label>
        </Container>
    )
}

export default ZoomMakerDownloadLoader
